import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import AppEnvironment from '../../../../../components/enums/appEnvironment.enum';
import api from '../../../../../services/api';
import { useAppEnvironmentStore } from '../../../../../stores/AppEnvironment/appEnvironment.store';
import { UserRole } from '../../../../users/roles';
import { loggedAsStore } from '../../../contextUtils';

const useAppEnvironment = () => {
  const { handleChangeAppEnvironment } = useAppEnvironmentStore(
    useShallow((state) => ({
      handleChangeAppEnvironment: state.handleChangeAppEnvironment,
    })),
  );

  const getEnvironment = useCallback((userRole?: UserRole, brandId?: string) => {
    if (loggedAsStore(userRole) && !brandId) {
      return AppEnvironment.STORE;
    }
    return AppEnvironment.BRAND;
  }, []);

  const handleApplyEnvironment = useCallback(
    (environment: AppEnvironment) => {
      api.setAppEnvironment(environment);
      handleChangeAppEnvironment(environment);
    },
    [handleChangeAppEnvironment],
  );

  const applyEnvironment = useCallback(
    (userRole?: UserRole, brandId?: string) => {
      const environment = getEnvironment(userRole, brandId);
      handleApplyEnvironment(environment);
    },
    [getEnvironment, handleApplyEnvironment],
  );

  const applyStoreEnvironment = useCallback(() => {
    handleApplyEnvironment(AppEnvironment.STORE);
  }, [handleApplyEnvironment]);

  const applyBrandEnvironment = useCallback(() => {
    handleApplyEnvironment(AppEnvironment.BRAND);
  }, [handleApplyEnvironment]);

  return { getEnvironment, applyEnvironment, applyStoreEnvironment, applyBrandEnvironment };
};

export default useAppEnvironment;
